import IRegisterAccount, {
    ICreateUserAccountResponse,
    IRegisterApiResponse,
    IRegistrationTokensResponse
} from "../models/account/IRegisterAccount";
import IResetPassword, {
    IForgotPasswordApiResponse,
    IResetPasswordApiResponse,
    ISetPassword,
    ISetPasswordApiResponse
} from "../models/account/IResetPassword";
import { IUserListResponse } from "../models/account/IUserInfo";
import IUserProfile, {
    IUpdateUserProfileResponse,
    IUserProfileResponse
} from "../models/account/IUserProfile";
import HttpProvider from "../providers/HttpProvider";

export default class AccountApi {
    public static async Login(
        email: string,
        password: string
    ): Promise<string> {
        const uriStr = `${this.apiUrl}/login`;

        const response = await HttpProvider.PostRequest(uriStr, {
            Email: email,
            Password: password
        });

        if (response.ok) {
            return await response.json();
        }

        return "";
    }

    public static async Register(
        newAcct: IRegisterAccount
    ): Promise<IRegisterApiResponse> {
        const uriStr = `${this.apiUrl}/register`;
        const response = await HttpProvider.PostRequest(uriStr, newAcct);

        const result = {} as IRegisterApiResponse;

        if (response.ok) {
            result.token = await response.json();
        } else {
            result.errors = await response.json();
        }

        return result;
    }

    public static async DeleteUser(email: string): Promise<boolean> {
        const uriStr = `${this.apiUrl}/delete-user`;
        const body = { email };
        const response = await HttpProvider.PostRequest(uriStr, body);

        if (response.ok) {
            return true;
        }

        return false;
    }

    public static async GetRegistrationTokens(): Promise<IRegistrationTokensResponse> {
        const uriStr = `${this.apiUrl}/get-registration-tokens`;

        const response = await HttpProvider.GetRequest(uriStr);
        if (!response.ok) {
            return {} as IRegistrationTokensResponse;
        }

        return await response.json();
    }

    public static async ForgotPassword(
        email: string
    ): Promise<IForgotPasswordApiResponse> {
        const uriStr = `${this.apiUrl}/forgot-password`;
        const response = await HttpProvider.PostRequest(uriStr, {
            Email: email
        });

        const result = {} as IForgotPasswordApiResponse;

        if (response.ok) {
            result.token = await response.json();
        } else {
            result.errors = await response.json();
        }

        return result;
    }

    public static async ResetPassword(
        acct: IResetPassword
    ): Promise<IResetPasswordApiResponse> {
        const uriStr = `${this.apiUrl}/reset-password`;
        const response = await HttpProvider.PostRequest(uriStr, acct);

        const result = {} as IRegisterApiResponse;

        if (response.ok) {
            result.token = await response.json();
        } else {
            result.errors = await response.json();
        }

        return result;
    }

    public static async GetUserProfile(
        email: string
    ): Promise<IUserProfileResponse> {
        const uriStr = `${this.apiUrl}/get-user-profile`;
        const queryParams = { email };

        const response = await HttpProvider.GetRequest(uriStr, queryParams);
        const result = {} as IUserProfileResponse;
        if (response.ok) {
            result.profile = await response.json();
        } else {
            result.errors = await response.json();
        }

        return result;
    }

    public static async UpdateUserStatus(
        email: string,
        enable: boolean
    ): Promise<boolean> {
        const uriStr = `${this.apiUrl}/update-user-status`;
        const body = { email, enable };
        const response = await HttpProvider.PostRequest(uriStr, body);

        if (response.ok) {
            return true;
        }

        return false;
    }

    public static async UpdateUserProfile(
        userProfile: IUserProfile
    ): Promise<IUpdateUserProfileResponse> {
        const uriStr = `${this.apiUrl}/update-user-profile`;
        const response = await HttpProvider.PostRequest(uriStr, userProfile);

        const result = {} as IUpdateUserProfileResponse;

        if (response.ok) {
            result.token = await response.json();
        } else {
            result.errors = await response.json();
        }

        return result;
    }

    public static async ResetPasswordTokenCheck(
        token: string
    ): Promise<boolean> {
        const uriStr = `${this.apiUrl}/reset-password-token-check/${token}`;
        const response = await HttpProvider.GetRequest(uriStr);

        if (!response.ok) {
            return false;
        }

        return await response.json();
    }

    public static async GetUsers(): Promise<IUserListResponse> {
        const uriStr = `${this.apiUrl}/get-user-list`;
        const response = await HttpProvider.GetRequest(uriStr);

        if (!response.ok) {
            return { administrators: [], bidders: [] } as IUserListResponse;
        }

        return await response.json();
    }

    public static async CreateUserAccount(
        userProfile: IUserProfile
    ): Promise<ICreateUserAccountResponse> {
        const uriStr = `${this.apiUrl}/create-user-account`;
        const response = await HttpProvider.PostRequest(uriStr, userProfile);

        const result = {} as ICreateUserAccountResponse;

        if (response.ok) {
            result.userId = await response.json();
        } else {
            result.errors = await response.json();
        }

        return result;
    }

    public static async SetPassword(
        setPassword: ISetPassword
    ): Promise<ISetPasswordApiResponse> {
        const uriStr = `${this.apiUrl}/set-password`;
        const response = await HttpProvider.PostRequest(uriStr, setPassword);

        const result = {} as ISetPasswordApiResponse;

        if (response.ok) {
            result.userId = await response.json();
        } else {
            result.errors = await response.json();
        }

        return result;
    }

    private static readonly apiUrl = "/api/account";
}
